<ng-container *ngIf="(!(resultAccounts$ | async) || (resultAccounts$ | async)?.length) && !showError">
    <div class="content-pane no-padding">
        <ng-container>
            <ol class="results">
                <li
                    *ngFor="let account of (btaxStateLoaded$ | async) ? (resultAccounts$ | async) : nullAccounts; trackBy: resultsTrackBy"
                    class="listing-item no-padding clickable highlight-on-hover"
                    [routerLink]="account?.link"
                >
                    <btax-result-item [account]="account"></btax-result-item>
                </li>
            </ol>
        </ng-container>
    </div>
    <app-load-more *ngIf="showLoadMore" label="Load more" (click)="loadMore()" [loading]="loadingMore" [disabled]="loadMoreDisabled"></app-load-more>
</ng-container>
<app-content-placeholder
    *ngIf="(resultAccounts$ | async) && !(resultAccounts$ | async)!.length"
    customMessage="No businesses found for this search."
></app-content-placeholder>
<app-content-placeholder
    *ngIf="showError"
    type="error"
    [showRetry]="showErrorRetry"
    (retry)="retry()"
    customMessage="Error retrieving businesses."
></app-content-placeholder>
